export default (products) => !!products.find((product) => product.get('cashbackAvailable'));
